var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericStep',_vm._b({},'GenericStep',_vm.$attrs,false),[_c('BackgroundOverviewCard',{staticClass:"mb-4"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }